import React, { Component } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import FormikInputField from '~/components/formikInputField/formikInputField';

export const getLocationsQuery = gql`
  query locations($breweryId: Int!) {
    locations(breweryId: $breweryId) {
      id
      name
    }
  }
`;

export class LocationDropdown extends Component {
  render() {
    const { name, brewery, className, value } = this.props;
    return (
      <Query query={getLocationsQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <p className="ma0">Getting locations</p>;
          }

          if (error) {
            return <p className="ma0">Error getting locations</p>;
          }

          return (
            <FormikInputField type="select" name={name} className={className} value={value}>
              <option />
              {data.locations.map(t => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </FormikInputField>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(LocationDropdown);



// WEBPACK FOOTER //
// ./src/containers/locationDropdown/locationDropdown.jsx